enum ProjectActivityType {
    NoActivities = "no_activities",
    CaughtUp = "caught_up",
    ProjectCreated = "project_created",
    ProjectUserJoined = "project_user_joined",
    UserCreateScreen = "user_create_screen",
    UserCreateScreenVersion = "user_create_screen_version",
    UserCreateScreenCommentMention = "user_create_screen_comment_mention",
    UserUpdateScreenStatusTag = "user_update_screen_status_tag",
}

export function isScreenActivityType(
    type: ProjectActivityType
): type is ProjectActivityType.UserCreateScreen | ProjectActivityType.UserCreateScreenVersion {
    return type === ProjectActivityType.UserCreateScreen ||
        type === ProjectActivityType.UserCreateScreenVersion;
}

export default ProjectActivityType;
